module.exports = __webpack_public_path__ + "img/048-impatient.734b4c92.png";